/** 
 * *******************************************************************************************************
 * *******************************************************************************************************
 * OS ITENS COMENTADOS SÃO REFERENTES AO QRCODE, QUANDO O TAG COM QRCODE ESTA FUNCIONALIDADE SERÁ LIBERADA
 * NÃO APAGAR OS ITENS COMENTADOS!!!
 * *******************************************************************************************************
 * *******************************************************************************************************
 * *******************************************************************************************************
 */


import React, {Component} from 'react';
import {Grid, Form, Segment, Button, Header, Image} from 'semantic-ui-react';
// import QrReader from 'react-qr-reader';
import CodeBar from '../main/CodeBar';

//css
import './../assets/css/sticker.css';

const image = require('./../assets/images/logo.png');

export class Step2 extends Component {
    
    constructor () {
        super()
        
        this.state = {
            errors: [],
            loading: false,        
            toSticker: false,
            buttonQRCode: false,//default
            buttonBarCode: true,//default
            toSuccess: false
        }

        this.handleClickQRCode = this.handleClickQRCode.bind(this);
        this.handleClickBarCode = this.handleClickBarCode.bind(this);
        this.handleScan = this.handleScan.bind(this);
    }

    handleScan = data => {
        if (data) {
            this.props.setNumberTag(data)
        }
    }

    handleError = err => {
        console.error(err)
    }

    handleClickQRCode = (e) => {
        e.preventDefault();
        // if(!this.state.buttonQRCode){
        //     this.emptyNumberTag()
        //     this.setState({
        //         buttonQRCode:!this.state.buttonQRCode,
        //         buttonBarCode: false
        //     })
        // }
    };

    handleClickBarCode = (e) => {
        e.preventDefault();
        if(!this.state.buttonBarCode){
            this.emptyNumberTag()
            this.setState({
                buttonBarCode:!this.state.buttonBarCode,
                buttonQRCode: false
            })
        }
    };

    emptyNumberTag() {
        this.props.setNumberTag('')
    }

    componentDidMount(){
        // this.validateCamera()        
        this.props.setNumberTag('')
    }

    // validateCamera(){

    //     if (window.navigator.userAgent.indexOf("Mac") !== -1){
    //         //
    //     }else{
    //         var constraints = { video: true }; 
  
    //         navigator.mediaDevices.getUserMedia(constraints)
    //         .then(function(mediaStream) {
    //             //
    //         })
    //         .catch(function(err) { 
    //             console.log(err.name + ": " + err.message); 
    //             alert("Não foi localizado o dispositivo de captura, ou o mesmo está bloqueado. Por favor verifique para continuar o cadastro ou preencha manualmente o número da tag.");
    //         }); 
    //     }      
    // }

    render() { 

        const { loading } = this.state

        const button = {
            color: '#fff',
            backgroundColor: '#d60b52'
        }

        const magentoColor = {
            color: '#d60b52'
        }

        if (this.props.currentStep !== 2) {
            return null
        }

        const buttonInserOrUpdate = this.props.acao !== "i" ?  "Atualizar" : "Cadastrar"

        return (

            <Grid textAlign='center' style={{ height: '100vh', marginTop: '0px' }} verticalAlign='middle'>
                <Grid.Column style={{ maxWidth: 450, width: '90vw' }}>
                    <Form onSubmit={this.props.handleSubmitStep2} size='large'>
                        <Segment stacked>
                            <Header as='h2' style={magentoColor} textAlign='center'>
                                <Image style={{width: '80%'}} src={image} /> 
                            </Header>

                            <div className="field">
                                <div className="QRCode">
                                    <div className="ui two bottom attached buttons">
                                        <div 
                                            className={`
                                            ui button
                                            ${this.state.buttonBarCode === true ? 'habilitado' : 'desabilitado'}
                                            `} 
                                            onClick={this.handleClickBarCode}>
                                            Código de Barras
                                        </div>
                                        {/* <div className="or"></div>
                                        <div
                                            className={`
                                            ui button
                                                ${this.state.buttonQRCode === true ? 'habilitado' : 'desabilitado'}
                                                `} 
                                            onClick={this.handleClickQRCode}>
                                                QR Code
                                        </div> */}
                                    </div>
                                </div>
                            </div>

                            <div className="field">
                                <div style={{width: '100%'}}>
                                    
                                    { this.state.buttonQRCode ? 
                                    // <QrReader
                                    // delay={300}
                                    //     onError={this.handleError}
                                    //     onScan={this.handleScan}
                                    //     style={{ width: '100%' }}
                                    //     />
                                    null
                                        : 
                                        
                                        <CodeBar 
                                        onError={this.handleError}
                                        onScan={this.handleScan} />
                                        
                                    }
                                </div>                                
                            </div>
                            {this.props.children}                             
                            
                            <div className="ui divider"></div>

                            <div className="ui two top attached buttons">
                                <Button 
                                    className={loading ? 'loading' : ''} 
                                    style={button} 
                                    fluid 
                                    size="large"
                                    type="button"
                                    onClick={this.props._prev}>
                                    Voltar
                                </Button>
                                <div className="or"></div>
                                <Button 
                                    className={loading ? 'loading' : ''}
                                    style={button} 
                                    fluid 
                                    size="large"
                                    >
                                    {buttonInserOrUpdate}
                                </Button>
                            </div>

                        </Segment>
                    </Form>

                </Grid.Column>
            </Grid>
        )
    }
}


export default Step2;